import { useState } from 'react';
import ContactModal from './ContactModal';

export default function Footer() {
  const [showContact, setShowContact] = useState(false);
  const [email, setEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState('');

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;

    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d6m40505dsf7sr1n6630', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      if (response.ok) {
        setSubscribeStatus('Thank you for subscribing!');
        setEmail('');
        setTimeout(() => setSubscribeStatus(''), 3000);
      } else {
        setSubscribeStatus('Subscription failed. Please try again.');
      }
    } catch (error) {
      setSubscribeStatus('An error occurred. Please try again.');
    }
  };

  return (
    <>
      <footer id="contact" className="bg-[#001F3F] mx-8 mb-8 rounded-3xl relative overflow-hidden">

        <div className="relative z-10 max-w-7xl mx-auto px-12 py-20">
          <div className="grid grid-cols-12 gap-8 mb-16 relative">

            {/* Brand — col 1-3 */}
            <div className="col-span-3">
              <h3 className="text-4xl font-bold text-white mb-4 leading-tight">InovaBioCorp</h3>
              <p className="text-sm text-[#FFD700]">Global Scientific Excellence</p>
            </div>

            {/* Divisions — col 4-5 */}
            <div className="col-span-2">
              <h4 className="text-xs font-semibold text-white mb-5 uppercase tracking-widest">
                Divisions
              </h4>
              <ul className="space-y-3">
                <li>
                  <a href="#medical-devices" className="text-sm text-[#9CA3AF] hover:text-white transition-colors">
                    InovaBioTech
                  </a>
                </li>
                <li>
                  <a href="#pharmaceuticals" className="text-sm text-[#9CA3AF] hover:text-white transition-colors">
                    InovaBioChem
                  </a>
                </li>
                <li>
                  <a href="#research-labs" className="text-sm text-[#9CA3AF] hover:text-white transition-colors">
                    InovaBioLabs
                  </a>
                </li>
                <li>
                  <button
                    onClick={() => setShowContact(true)}
                    className="text-sm text-[#9CA3AF] hover:text-white transition-colors cursor-pointer text-left"
                  >
                    Careers
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => setShowContact(true)}
                    className="text-sm text-[#9CA3AF] hover:text-white transition-colors cursor-pointer text-left"
                  >
                    Locations
                  </button>
                </li>
              </ul>
            </div>

            {/* Connect — col 6-7 */}
            <div className="col-span-2">
              <h4 className="text-xs font-semibold text-white mb-5 uppercase tracking-widest">
                Connect
              </h4>
              <ul className="space-y-3">
                <li>
                  <a
                    href="https://linkedin.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 text-sm text-[#9CA3AF] hover:text-white transition-colors"
                  >
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-linkedin-fill text-[#0A66C2]"></i>
                    </span>
                    LinkedIn
                  </a>
                </li>
                <li>
                  <a
                    href="https://researchgate.net"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 text-sm text-[#9CA3AF] hover:text-white transition-colors"
                  >
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-flask-line text-[#00D0B5]"></i>
                    </span>
                    ResearchGate
                  </a>
                </li>
                <li>
                  <a
                    href="https://youtube.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 text-sm text-[#9CA3AF] hover:text-white transition-colors"
                  >
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-youtube-fill text-[#FF0000]"></i>
                    </span>
                    YouTube
                  </a>
                </li>
              </ul>
            </div>

            {/* Empty spacer col — col 8-9 — this is the open blue area */}
            <div className="col-span-2 flex items-center justify-center">
              <span
                className="font-black text-[#FFD700] tracking-widest whitespace-nowrap select-none pointer-events-none"
                style={{
                  fontSize: '52px',
                  opacity: 0.08,
                  writingMode: 'vertical-rl',
                  textOrientation: 'mixed',
                  transform: 'rotate(180deg)',
                }}
              >
                INOVABIO
              </span>
            </div>

            {/* Newsletter — col 10-12 */}
            <div className="col-span-3">
              <h4 className="text-xs font-semibold text-white mb-5 uppercase tracking-widest">
                Newsletter
              </h4>
              <p className="text-sm text-white font-medium mb-1 leading-snug">
                Stay Updated on Scientific Advances
              </p>
              <p className="text-xs text-[#9CA3AF] mb-4">Quarterly research insights</p>
              <form
                id="newsletter-form"
                data-readdy-form
                onSubmit={handleSubscribe}
                className="flex items-center gap-2"
              >
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Email address"
                  required
                  className="flex-1 min-w-0 px-4 py-3 bg-[#002B5C] text-white text-sm rounded-lg border border-[#1565C0] focus:outline-none focus:border-[#FFD700] placeholder-[#9CA3AF]"
                />
                <button
                  type="submit"
                  className="w-11 h-11 flex-shrink-0 rounded-full bg-white flex items-center justify-center hover:bg-[#FFD700] transition-colors cursor-pointer whitespace-nowrap"
                  aria-label="Subscribe"
                >
                  <i className="ri-arrow-right-line text-[#002B5C] text-lg"></i>
                </button>
              </form>
              {subscribeStatus && (
                <p className="text-xs text-[#FFD700] mt-2">{subscribeStatus}</p>
              )}
            </div>
          </div>

          <div className="pt-8 border-t border-white/10">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <p className="text-sm text-[#9CA3AF]">
                © 2024 InovaBioCorp. All rights reserved.
              </p>
              <div className="flex items-center gap-6">
                <button
                  onClick={() => setShowContact(true)}
                  className="text-sm text-[#9CA3AF] hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  Privacy Policy
                </button>
                <button
                  onClick={() => setShowContact(true)}
                  className="text-sm text-[#9CA3AF] hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  Terms of Service
                </button>
                <button
                  onClick={() => setShowContact(true)}
                  className="text-sm text-[#9CA3AF] hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  Contact Us
                </button>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {showContact && <ContactModal onClose={() => setShowContact(false)} />}
    </>
  );
}